import React from 'react'
import { Link } from 'react-router-dom'
import app from '../../feathers'
import styled from 'styled-components'
import ScrollingDialog from '../../components/ScrollingDialog'
import Button from '../../components/Button'
import BlockingSpinner from '../components/BlockingSpinner'
import { Textfield } from 'react-mdl'

import UnitElementField from '../CreateUnit/UnitElementField'

const Container = styled.div`
  width: 700px;
  display: flex;
  justify-content: space-between;
`
const UnitElementContainer = styled.div`
  width: 900px;
`
const InputsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`
const StyledTextfield = styled(Textfield)`
  width: 550px;
`

const units = app.service('units')
class DuplicateDialog extends React.Component {
  state = {
    unit: null,
  }

  async componentDidMount() {
    const unit = await units.get(this.props.match.params.unitId)
    this.setState({ unit })
  }

  duplicateUnit = async () => {
    const { unit } = this.state
    // ensure _id is unique
    delete unit._id
    // ensure these are current on new unit on creation
    delete unit.createdAt
    delete unit.updatedAt

    // clear out all the mappings
    unit.formativePracticalAssessment.forEach(item => {
      item.mapping = []
    })
    unit.summativePracticalAssessments.forEach(item => {
      item.mapping = []
    })
    unit.sections.forEach(section => {
      this.removeSubsectionMappings(section)
    })

    const newUnit = await units.create(unit)
    this.props.history.push(`/units/${newUnit._id}/`)
  }
  
  // recursively clears out mappings from all subsections.
  removeSubsectionMappings = (section) => {
    // some sections have questions which can also have mappings
    if(section.questions && Array.isArray(section.questions)) {
      section.questions.forEach(q => {
        if(q.mapping) q.mapping = []
      })
    }
    if(section.subsections && Array.isArray(section.subsections)) {
      section.subsections.forEach(sub => {
        if(sub.mapping) sub.mapping = []
        this.removeSubsectionMappings(sub)  // recursively remove sub-subsections
      })
    }
  }
 
  handleChange = ({ target }) =>
    this.setState({
      unit: {
        ...this.state.unit,
        [`${target.name}`]: target.value,
      },
    })

  onChangePerformanceCriteria = performanceCriteria =>
    this.setState({
      unit: {
        ...this.state.unit,
        performanceCriteria,
      },
    })
  onChangePerformanceEvidence = performanceEvidence =>
    this.setState({
      unit: {
        ...this.state.unit,
        performanceEvidence,
      },
    })
  onChangeKnowledgeEvidence = knowledgeEvidence =>
    this.setState({
      unit: {
        ...this.state.unit,
        knowledgeEvidence,
      },
    })

  render() {
    const { unit } = this.state
    return (
      <ScrollingDialog
        title="Duplicate Unit"
        actions={
          <Container>
            <Link to="/units/">
              <Button>Cancel</Button>
            </Link>
            <Button
              primary
              onClick={this.duplicateUnit}
              disabled={
                unit == null ||
                (unit && (!unit.code || !unit.title || !unit.industry))
              }
              onDisabledClick={() =>
                alert(
                  'Please ensure all fields are filled before attempting to submit form.',
                )}>
              Duplicate Unit
            </Button>
          </Container>
        }>
        {!unit
          ? <BlockingSpinner>
            <h1>Loading...</h1>
          </BlockingSpinner>
          : <InputsContainer>
            <Container>
              <h6>
                <b>Unit Code</b>
              </h6>
              <StyledTextfield
                required
                name="code"
                label="New Unit Code"
                onChange={this.handleChange}
                value={unit.code}
              />
            </Container>
            <Container>
              <h6>
                <b>Unit Title</b>
              </h6>
              <StyledTextfield
                required
                name="title"
                label="New Unit Title"
                onChange={this.handleChange}
                value={unit.title}
              />
            </Container>
            <Container>
              <h6>
                <b>Unit Industry</b>
              </h6>
              <StyledTextfield
                required
                name="industry"
                label="New Unit Industry"
                onChange={this.handleChange}
                value={unit.industry}
              />
            </Container>
            <UnitElementContainer>
              <UnitElementField
                title="Performance Criteria"
                onChange={this.onChangePerformanceCriteria}
                elements={unit.performanceCriteria}
              />
            </UnitElementContainer>
            <UnitElementContainer>
              <UnitElementField
                title="Performance Evidence"
                onChange={this.onChangePerformanceEvidence}
                elements={unit.performanceEvidence}
              />
            </UnitElementContainer>
            <UnitElementContainer>
              <UnitElementField
                title="Knowledge Evidence"
                onChange={this.onChangeKnowledgeEvidence}
                elements={unit.knowledgeEvidence}
              />
            </UnitElementContainer>
          </InputsContainer>}
      </ScrollingDialog>
    )
  }
}

export default DuplicateDialog



// WEBPACK FOOTER //
// ./src/Units/UnitsScreen/DuplicateDialog.js